import { Component, OnInit } from "@angular/core";
import { MetaService } from "../meta.service";
import { Router } from "@angular/router";
import { PicklistsService } from "../picklists.service";

@Component({
	selector: "join-movement-contact",
	templateUrl: "./join-movement-contact.component.html",
	styleUrls: ["./join-movement-contact.component.css"],
})
export class JoinMovementContactComponent implements OnInit {
	//declare variables
	bRobot: boolean = false;
	reasons: any[] = [];
	industries: any[] = [];

	//inject services
	constructor(
		private mds: MetaService,
		private router: Router,
		private pls: PicklistsService
	) {}

	//initialize the component
	ngOnInit(): void {
		//SEO Optimization
		var strTitle = "RegScale";
		var description =
			"Continuous Compliance Automation Platform for Highly Regulated Industries";
		var keywords =
			"RegScale, SMB, Small, Medium, Business, CMMC, compliance, cyber security, audits, cost savings, issues management, vendor management";
		this.mds.updateTags(strTitle, keywords, description);

		//get picklists
		this.reasons = this.pls.getContactReasons();
		this.industries = this.pls.getIndustries();
	}

	//save a new contact
	save() {
		//navigate to the thank you page
		this.router.navigate(["/thank-you/contact"]);
	}
}
